import script from "./CustomerDashboardLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomerDashboardLayout.vue?vue&type=script&setup=true&lang=js"

import "./CustomerDashboardLayout.vue?vue&type=style&index=0&id=743fc8da&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-743fc8da"]])

export default __exports__